import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 21h3.5l2.5 -6l2.5 -1l2.5 7h4l1 -4.5l-2 -1l-7 -12l-6 -.5l1.5 4l2.5 .5l1 2.5l-7 8l1 3","key":"svg-0"}]]

/**
 * IconBrandLinqpad
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbGlucXBhZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNSAyMWgzLjVsMi41IC02bDIuNSAtMWwyLjUgN2g0bDEgLTQuNWwtMiAtMWwtNyAtMTJsLTYgLS41bDEuNSA0bDIuNSAuNWwxIDIuNWwtNyA4bDEgMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-linqpad
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandLinqpad = createReactComponent('outline', 'brand-linqpad', 'BrandLinqpad', __iconNode);

export default IconBrandLinqpad;